import { Injectable } from '@angular/core';
import { BaseService } from '../../../../core/base/base.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { ObjectApiInterface } from '../../../../core/base/interfaces/object-api.interface';
import { ImportInstructionModel } from '../../../../core/models/import-instruction.model';
import { AuthService } from '../../../../core/services/auth.service';

@Injectable({ providedIn: 'root' })
export class ImportInstructionService extends BaseService<ImportInstructionModel> {
  constructor(
    public override http: HttpClient,
    public authService: AuthService,
  ) {
    super(http, 'import-instructions', authService);
  }

  exportDocx(id: string): void {
    this.http
      .post(`/api/import-instructions/${id}/export-docx`, {}, { responseType: 'blob', observe: 'response' })
      .subscribe(res => {
        const blob = res.body as Blob;
        // Try to get filename from Content-Disposition header
        let filename = `mode-emploi-${id}.docx`;
        const cd = res.headers?.get('content-disposition') || res.headers?.get('Content-Disposition');
        if (cd) {
          const match = /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i.exec(cd);
          const fromHeader = decodeURIComponent(match?.[1] || match?.[2] || '').trim();
          if (fromHeader) filename = fromHeader;
        } else if (blob?.type === 'application/msword') {
          filename = `mode-emploi-${id}.doc`;
        }

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      });
  }
}
